module.exports = __webpack_public_path__ + "static/media/ico-copy.2d711b8b.svg";